export default __webpack_public_path__ + "static/media/LIVERPOOL_ECHO.14f56b00.png";